import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {ActivityCondition} from "../../../../../../models/activity-condition";
import {ActivityConditionType} from "../../../../../../models/activity-condition-type";
import {Law} from "../../../../../../models/laws";
import {Registration} from "../../../../../../models/registration";
import {RegistrationActivityCondition} from "../../../../../../models/registration-activity-condition";
import {ActivityConditionControllerService} from "../../../../../../services/activity-condition/activity-condition-controller.service";
import {ActivityConditionService} from "../../../../../../services/activity-condition/activity-condition.service";
import {RegistrationActivityConditionControllerService} from "../../../../../../services/activity-condition/registration-activity-condition-controller.service";
import {ActivityConditionTypeControllerService} from "../../../../../../services/classifications-controller/activity-condition-type-controller.service";
import {LawControllerService} from "../../../../../../services/laws-controller/law-controller.service";
import {Store} from "../../../../../../services/store.service";
import {TranslatedBaseError} from "../../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {
  DeterminantControllerService,
} from "../../../../../../services/registration-controller/determinant-controller.service";

@Component({
  selector: "activity-condition-list",
  templateUrl: "./activity-condition-list.component.html",
  providers: [],
  styles: [],
})
export class ActivityConditionListComponent extends TranslatedBaseError implements OnInit, OnDestroy {

  public registration: Registration;
  public serviceId: string;
  public registrationActivityConditionList: RegistrationActivityCondition[] = [];
  public registrationActivityCondition: RegistrationActivityCondition;
  public activityCondition: ActivityCondition;
  public activityConditions: ActivityCondition[];
  public topLayer = "list";
  public listToggle: boolean = false;
  public userFilter: any = {name: ""};
  public laws: Law[] = [];
  public activityConditionTypes: ActivityConditionType[] = [];
  public subscription: any;
  public determinantMapById: { [key: string]: string } = {};

  constructor(private activityConditionControllerService: ActivityConditionControllerService,
              private registrationActivityConditionControllerService: RegistrationActivityConditionControllerService,
              public activityConditionService: ActivityConditionService,
              public lawControllerService: LawControllerService,
              public determinantService: DeterminantControllerService,
              public activityConditionTypeControllerService: ActivityConditionTypeControllerService,
              public store: Store,
              public toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.subscription = this.activityConditionService.change.subscribe((data) => {
      this.registration = data.registration;
      this.serviceId = data.serviceId;
      this.registrationActivityConditionList = data.registrationActivityConditionList;
      this.activityConditions = data.activityConditions;
      this.initData();
      this.getServiceDeterminantKeyName();
    });
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public initData() {
   this.loadLaws();
   this.loadActivityConditionTypes();
  }

  public saveRegistrationActivityCondition(activityCondition) {
    if (this.registration !== undefined) {

      this.activityCondition = activityCondition;
      this.registrationActivityCondition = new RegistrationActivityCondition();
      this.registrationActivityCondition.activityConditionId = this.activityCondition.id;

      this.registrationActivityConditionControllerService.createActivityCondition(this.registration.id, this.registrationActivityCondition).subscribe(
        () => {
          this.activityConditionService.updateData();
          this.responseSuccessful("Condition added to registration");
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
      );
    }
  }

  public updateRegistrationActivityCondition(registrationActivityCondition) {
    this.registrationActivityConditionControllerService.saveRegistrationActivityCondition(registrationActivityCondition).subscribe(
      () => this.responseSuccessful("Condition Registration updated"),
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
    );
  }

  public deleteRegistrationActivityCondition(activityCondition) {
    let registrationActivityCondition;
    if (this.registrationActivityConditionList && this.registrationActivityConditionList.length > 0) {
       this.registrationActivityConditionList.forEach((thisActivityCondition: any) => {
         if (thisActivityCondition.activityConditionId === activityCondition.id) {
           registrationActivityCondition = thisActivityCondition;
         }
       });
    }
    this.registrationActivityConditionControllerService.deleteRegistrationActivityCondition(registrationActivityCondition.id).subscribe(
      () => {
        this.activityConditionService.updateData();
        this.responseSuccessful("Condition removed from registration");
      },
    );
  }

  public deleteActivityCondition(isConfirmed, activityCondition) {
    if (isConfirmed) {
      this.activityConditionControllerService.deleteActivityCondition(activityCondition.id).subscribe(
        () => {
          this.activityConditionService.updateData();
          this.responseSuccessful("Condition deleted");
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public loadLaws() {
    this.lawControllerService.getLawsList().subscribe(
      (data) => {
        this.laws = data;
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public loadActivityConditionTypes() {
    this.activityConditionTypeControllerService.getConditionTypes().subscribe(
      (data) => {
        this.activityConditionTypes = data;
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public openEdit(activityCondition: any) {
    if (activityCondition) {
      this.activityCondition = activityCondition;
      this.registrationActivityCondition = new RegistrationActivityCondition();
      if (this.registrationActivityConditionList && this.registrationActivityConditionList.length > 0) {
         this.registrationActivityConditionList.forEach((thisActivityCondition: any) => {
           if (thisActivityCondition.activityConditionId === activityCondition.id) {
             this.registrationActivityCondition = thisActivityCondition;
           }
         });
      }
    } else {
      this.activityCondition = new ActivityCondition();
    }
    this.topLayer = "edit";
  }

  public closeLayer() {
    this.store.state.common.sections.active = false;
    this.store.state.common.sections.type = undefined;
  }

  public submitEdit(event) {
    if (event.registrationActivityCondition && event.registrationActivityCondition.id) {
      this.updateRegistrationActivityCondition(event.registrationActivityCondition);
    }
    this.activityConditionService.updateData();
    this.topLayer = "list";
  }

  public cancelEdit(event) {
    if (event.cancel) {
      this.topLayer = "list";
    }
  }

  public isActive(activityCondition) {
    let activityConditionActive = false;
    if (this.registrationActivityConditionList && this.registrationActivityConditionList.length > 0) {
       this.registrationActivityConditionList.forEach((thisActivityCondition: any) => {
         if (thisActivityCondition.activityConditionId === activityCondition.id) {
           activityConditionActive = true;
         }
       });
    }
    return activityConditionActive;
  }

  public setListView(b) {
    this.listToggle = b;
  }

}
